const getCountText = require('./resultsPresenter/getCountText');
const resultPresenter = require('./resultsPresenter/resultPresenter');
const newSearchingPresenter = require('./resultsPresenter/searchingPresenter');
const debounce = require('lodash.debounce');
const {
    deactivate,
    negotiateCssClass,
} = require('gui');
const animateResultsText = debounce(require('./resultsPresenter/animateResultsText'), 300);

module.exports = function resultsPresenter(model) {
    const resultsModel = model.results;
    const hasSearchedModel = model.hasSearched;
    const view = require('./resultsPresenter.tpl.html');
    var c = {};
    var deactivator = deactivate();
    const searchingPresenter = newSearchingPresenter(model.isSearching);
    onHasSearchedChanged();

    c.activate = function(region) {
        view.activate(region);
        searchingPresenter.activate(view.searchingRegion);
        activateSubPresenters();
        resultsModel.subscribeCollectionChange(onResultsChanged);
        hasSearchedModel.subscribeChange(onHasSearchedChanged);
    };

    function activateSubPresenters() {
        for(let result of resultsModel.toArray()) {
            let presenter = resultPresenter(result);
            presenter.activate(view.resultsSection);
            deactivator.add(presenter);
        }
    }

    function onResultsChanged() {
        deactivator();
        animateResultsText(view.resultsCount, resultsModel.length);
        activateSubPresenters();
    }

    function onHasSearchedChanged() {
        negotiateCssClass(view.resultsText, 'resultsPresenter-hasSearched', hasSearchedModel());
    }

    c.deactivate = function() {
        hasSearchedModel.unsubscribeChange(onHasSearchedChanged);
        resultsModel.unsubscribeCollectionChange(onResultsChanged);
        searchingPresenter.deactivate();
        view.deactivate();
        deactivator();
    };

    return c;
};
